import React from 'react'
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { order } from "../../../actions/orderAction";
import { withRouter } from "react-router-dom";
import * as myConstList from '../../../BaseUrl';
import { toast, Toaster } from 'react-hot-toast';
import $ from 'jquery';
const baseUrl = myConstList.baseUrl;
const toastStyles = {
  style: {
    borderRadius: '10px',
    background: '#fff',
    color: '#000',
  },
}
class SellOrder extends React.Component {
  constructor(props) {
    super(props);
    const { user } = this.props.auth;
    this.state = {
      user_id: this.props.user_id,
      sprice: this.props.currentprice < 0.0001 && this.props.currentprice > 0.000001 ? parseFloat(this.props.currentprice).toFixed(8) : this.props.currentprice < 0.1 && this.props.currentprice > 0.0001 ? parseFloat(this.props.currentprice).toFixed(6) : this.props.currentprice < 1 && this.props.currentprice > 0.1 ? parseFloat(this.props.currentprice).toFixed(4) : this.props.currentprice > 1 ? parseFloat(this.props.currentprice).toFixed(2) : parseFloat(this.props.currentprice).toFixed(2),
      samount: "",
      message: "",
      CurrencyValue: this.props.CurrencyValue,
      errors: {},
      total: "",
      btnDisable: false,
      contestName: "",
      orderTypeText: false,
      stopLoss:0,
      limitSell:'active',
      orrderExecuteType:'limit',
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.user_id) {
      this.setState({
        user_id: nextProps.user_id
      });
    }
    if (nextProps.currentprice != undefined) {
      const spirceenter = nextProps.currentprice<0.0001 && nextProps.currentprice>0.000001?parseFloat(nextProps.currentprice).toFixed(8):nextProps.currentprice<0.1 && nextProps.currentprice>0.0001?parseFloat(nextProps.currentprice).toFixed(6):nextProps.currentprice<1 && nextProps.currentprice>0.1?parseFloat(nextProps.currentprice).toFixed(4):nextProps.currentprice>1?parseFloat(nextProps.currentprice).toFixed(2):parseFloat(nextProps.currentprice).toFixed(2)
      this.setState({
          sprice: spirceenter,
        });
    }
    if (nextProps.contestName != undefined) {
      this.setState({
        contestName: nextProps.contestName
      });
    }
    if (nextProps.CurrencyValue != undefined) {
      this.setState({
        CurrencyValue: nextProps.CurrencyValue
      });
    }
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors
      });
    }
    if (nextProps.orderdata !== undefined
      && nextProps.orderdata.order !== undefined
      && nextProps.orderdata.order.data !== undefined
      && nextProps.orderdata.order.data.message !== undefined
    ) {
      let mainSymbol = this.props.match.params.symbol.replace("-", "");
      let exchangeType = this.props.match.params.exchangetype;
      fetch(`${baseUrl}api/crpto-price?symbol=${mainSymbol}&&exchnageType=${exchangeType}`)
        .then(response => response.json())
        .then(response => {
          const convrtprice = response.price < 0.0001 && response.price > 0.000001 ? parseFloat(response.price).toFixed(8) : response.price < 0.1 && response.price > 0.0001 ? parseFloat(response.price).toFixed(6) : response.price < 1 && response.price > 0.1 ? parseFloat(response.price).toFixed(4) : response.price > 1 ? parseFloat(response.price).toFixed(2) : parseFloat(response.price).toFixed(2);
          // this.setState({ sprice: convrtprice });
        })
        .catch();
      //    toast( nextProps.orderdata.order.data.message2, {
      //         position: toast.POSITION.TOP_CENTER  
      //       });
      this.setState({
        total: "",
        samount: "",
        stopLoss: 0,
        btnDisable: false
      });
    }
  }
  onChange1 = e => {
    // console.log("keyCode===",e.target.key);
    this.setState({ message: "", errors: {} });
    if (e.target.id === 'user-update-id') {
      this.setState({ user_id: e.target.value });
    }
    if (e.target.id === 'sprice') {
      var total = (this.state.samount * e.target.value).toFixed(2);
      this.setState({ sprice: e.target.value, total: total });
    }
    if (e.target.id === 'samount') {
      var total = 0;
      if (isNaN(this.state.sprice)) {
        total = (this.state.samount * e.target.value).toFixed(2);
      } else {
        total = (this.state.sprice * e.target.value).toFixed(2);
      }
      // console.log("total===",isNaN(this.state.sprice),this.state.sprice,"=",this.state.samount);
      this.setState({ samount: e.target.value, total: total });
    }
    if (e.target.id === 'stopLoss') {
      if(e.target.value < this.state.sprice){
        this.setState({ stopLoss: "" });
        toast.error("Trigger Price should not be less than Order Price for Sell Order", toastStyles);
        return false;
      }
      this.setState({ stopLoss: e.target.value });
    }
  };
  onChange = e => {
    this.start = e.target.selectionStart;
    // console.log("thisstartthisstart", this.start);
    let val = e.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    // val = val.replace(/^(0|\.)/, "");
    const match = /(\d{0,7})[^.]*((?:\.\d{0,2})?)/g.exec(val);
    const value = match[1] + match[2];
    e.target.value = value;
    this.setState({ samount: value });
    if (val.length > 0) {
      e.target.value = Number(value).toFixed(2);
      e.target.setSelectionRange(this.start, this.start);
      this.setState({ samount: Number(value).toFixed(2) });
    }
    // console.log("keyCode===",e.target.key);
    this.setState({ message: "", errors: {} });
    if (e.target.id === 'user-update-id') {
      this.setState({ user_id: e.target.value });
    }
    if (e.target.id === 'sprice') {
      var total = (this.state.samount * e.target.value).toFixed(2);
      this.setState({ sprice: e.target.value, total: total });
    }
    if (e.target.id === 'samount') {
      var total = 0;
      if (isNaN(this.state.sprice)) {
        total = (this.state.samount * e.target.value).toFixed(2);
      } else {
        total = (this.state.sprice * e.target.value).toFixed(2);
      }
      // console.log("total===",isNaN(this.state.sprice),this.state.sprice,"=",this.state.samount);
      this.setState({ samount: e.target.value, total: total });
    }
    if (e.target.id === 'stopLoss') {
      this.setState({ stopLoss: e.target.value });
    }
  };
  handleKeyDown = event => {
    if (event.keyCode === 38 || event.keyCode === 40) {
      event.preventDefault();
    }
  };
  checkInput = e => {
    this.start = e.target.selectionStart;
    console.log("thisstartthisstart", this.start);
    let val = e.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    // val = val.replace(/^(0|\.)/, "");
    const match = /(\d{0,7})[^.]*((?:\.\d{0,2})?)/g.exec(val);
    const value = match[1] + match[2];
    e.target.value = value;
    this.setState({ samount: value });
    if (val.length > 0) {
      e.target.value = Number(value).toFixed(2);
      e.target.setSelectionRange(this.start, this.start);
      this.setState({ samount: Number(value).toFixed(2) });
    }
  };
  onClickData = (valueData) => {
    if (valueData === 'marketSell') {
      let mainSymbol = this.props.match.params.symbol.replace("-", "");
      let exchangeType = this.props.match.params.exchangetype;
      fetch(`${baseUrl}api/crpto-price?symbol=${mainSymbol}&&exchnageType=${exchangeType}`)
        .then(response => response.json())
        .then(response => {
          const convrtprice = response.price < 0.0001 && response.price > 0.000001 ? parseFloat(response.price).toFixed(8) : response.price < 0.1 && response.price > 0.0001 ? parseFloat(response.price).toFixed(6) : response.price < 1 && response.price > 0.1 ? parseFloat(response.price).toFixed(4) : response.price > 1 ? parseFloat(response.price).toFixed(2) : parseFloat(response.price).toFixed(2);
          this.setState({
            sprice: convrtprice,
            });
        });
      this.setState({ marketSell: 'active', limitSell: '', stopLimitSell: '', orderTypeText: true,orrderExecuteType:'market',samount:0,total:0});
    } else if (valueData === 'limitSell') {
      this.setState({ limitSell: 'active', marketSell: '', stopLimitSell: '', orderTypeText: false,orrderExecuteType:'limit',samount:0,total:0});
    } else if (valueData === 'stopLimitSell') {
      this.setState({ stopLimitSell: 'active', limitSell: '', marketSell: '', orderTypeText: false,orrderExecuteType:'stoploss',sprice:"",samount:0,total:0,stopLoss:0});
    }
    // console.log("e.tagetDataaa====",valueData);
    // this.setState({ bamount: value });
  }

  addQuantity =(percentageValue)=>{
    let currntBalance = this.state.CurrencyValue;
    let exactQuatity = currntBalance*percentageValue/100;
    let totalAmount = exactQuatity*this.state.sprice;
    // this.state.bprice
    // var btotal = (this.state.bprice * e.target.value).toFixed(2);
    this.setState({ samount: Number(exactQuatity).toFixed(2), total: totalAmount });
  }
  onOrderUpdate = e => {
    e.preventDefault();
    this.setState({ btnDisable: true });
    const { user } = this.props.auth;
    const convrtprice = this.state.sprice < 0.0001 && this.state.sprice > 0.000001 ? parseFloat(this.state.sprice).toFixed(8) : this.state.sprice < 0.1 && this.state.sprice > 0.0001 ? parseFloat(this.state.sprice).toFixed(6) : this.state.sprice < 1 && this.state.sprice > 0.1 ? parseFloat(this.state.sprice).toFixed(4) : this.state.sprice > 1 ? parseFloat(this.state.sprice).toFixed(2) : parseFloat(this.state.sprice).toFixed(2);
    let exchangeType = this.props.match.params.exchangetype.toLowerCase();

    if(this.state.stopLoss < this.state.sprice && this.state.orrderExecuteType ==='stoploss'){
      this.setState({ stopLoss: "" });
      toast.error("Trigger Price should not be less than Order Price for Sell Order", toastStyles);
      return false;
    }else{
      const newOrder = {
        user_id: user.id,
        price: convrtprice,
        contest_id: this.props.match.params.id,
        amount: this.state.samount,
        stopLoss: this.state.stopLoss,
        symbol: this.props.match.params.symbol,
        orderType: "Sell",
        exchange_type: exchangeType,
        orderExecuteType:this.state.orrderExecuteType,
      };
      window.webengage.track('Live Contest Coins Sold', {
        'Contest Name': this.state.contestName,
        'Prize': Number(convrtprice),
        'Quantity': Number(this.state.samount),
        'Coin Name': this.props.match.params.symbol,
        'Total': Number(parseFloat(convrtprice) * parseFloat(this.state.samount)),
        'Phone number': Number(user.mobile),
        'Name': user.name,
      });
      this.props.order(newOrder);
    }
  };
  render() {
    // console.log("this.state.sprice======",this.state.sprice);
    if (isNaN(this.state.sprice)) {
    } else if (this.state.sprice !== undefined && this.state.sprice !== NaN) {
      var prices = this.state.sprice;
    }
    const { errors } = this.state;
    const { user } = this.props.auth;
    return (
      <div className="col-md-6 tab-pane w_block" id="sell_tab">
        <form noValidate onSubmit={this.onOrderUpdate} id="update-user">
          {/* <span className="text-danger">{errors.balance}</span> */}
          <input onChange={this.onChange} value={this.state.user_id} id="user-update-id"
            type="text" className="d-none" />
          <div className="crypt-buy-sell-form">
            <div className="crypt-sell">
              <div className="row mb-2">
                <span className="col-3 pr-0">
                  Sell <span className="crypt-down">{this.props.match.params.symbol.replace("-", "").slice(0, -4)}</span>
                </span>
                <span className="fright col-9 tr">
                  <b className="crypt-down"> {this.props.match.params.symbol.replace("-", "").slice(0, -4)} Balance: {this.state.CurrencyValue < 0.0001 && this.state.CurrencyValue > 0.000001 ? parseFloat(this.state.CurrencyValue).toFixed(8) : this.state.CurrencyValue < 0.1 && this.state.CurrencyValue > 0.0001 ? parseFloat(this.state.CurrencyValue).toFixed(6) : this.state.CurrencyValue < 1 && this.state.CurrencyValue > 0.1 ? parseFloat(this.state.CurrencyValue).toFixed(4) : this.state.CurrencyValue > 1 ? parseFloat(this.state.CurrencyValue).toFixed(2) : parseFloat(this.state.CurrencyValue).toFixed(2)}
                    {/* {this.state.CurrencyValue.toFixed(6)} */}
                  </b>
                </span>
              </div>
              <div className='order-type-outer'>
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item">
                    <a className={this.state.limitSell ==='active'?'nav-link active':"nav-link"} onClick={() => this.onClickData('limitSell')} >Limit</a>
                  </li>
                  <li class="nav-item">
                    <a className={this.state.marketSell ==='active'?'nav-link active':"nav-link"} onClick={() => this.onClickData('marketSell')}>Market</a>
                  </li>
                  <li class="nav-item">
                    <a className={this.state.stopLimitSell ==='active'?'nav-link active':"nav-link"} onClick={() => this.onClickData('stopLimitSell')}>Stop Loss</a>
                  </li>
                </ul>
              </div>
              <span className="text-success">{this.state.message}</span>
              {this.state.stopLimitSell==='active' &&
              <div className="input-group mb-3">
                <div className="input-group-prepend"> <span
                  className="input-group-text">Limit</span> </div>
                <input onChange={this.onChange1} id="stopLoss" value={this.state.stopLoss}
                  type="number" className="form-control" placeholder="0.00" onKeyDown={this.handleKeyDown} onKeyUp={this.handleKeyUp} disabled={this.state.orderTypeText}/>
                <span className="text-danger">{errors.stopLoss}</span>
                <div className="input-group-append"> <span
                  className="input-group-text">USDT</span> </div>
              </div>
              }
              <div className="input-group mb-3">
                <div className="input-group-prepend"> <span
                  className="input-group-text">Price</span> </div>
                <input className="form-control" onChange={this.onChange1} id="sprice"
                  type={this.state.orrderExecuteType!=="market"?"number":"text"} value={this.state.orrderExecuteType==='market'?'Market':this.state.orrderExecuteType==='stoploss'?Number(this.state.sprice).toFixed(2):Number(this.state.sprice).toFixed(2)} placeholder="0.00" onKeyDown={this.handleKeyDown} onKeyUp={this.handleKeyUp} disabled={this.state.orderTypeText} />
                <span className="text-danger">{errors.sprice}</span>
                <div className="input-group-append"> <span
                  className="input-group-text">USDT</span> </div>
              </div>
              <div className="input-group mb-3">
                <div className="input-group-prepend"> <span
                  className="input-group-text">Quantity</span> </div>
                <input onChange={this.onChange} id="samount"
                  type="text" className="form-control" value={this.state.samount} placeholder="0.00" onKeyDown={this.handleKeyDown} onKeyUp={this.handleKeyUp} />
                <span className="text-danger">{errors.samount}</span>
                <div className="input-group-append"> <span
                  className="input-group-text">{this.props.match.params.symbol.replace("-", "").slice(0, -4)}</span> </div>
              </div>              
              {  /*
        <div className="input-group mb-3">
          <div className="input-group-prepend"> <span
            className="input-group-text">Stop Loss</span> </div>
          <input   onChange={this.onChange} value={this.state.stopLoss}  id="stopLoss"
            type="number" className="form-control" placeholder="0" />
          <span className="text-danger">{errors.stopLoss}</span>
        </div>
        */}
              <div className="input-group mb-3">
                <div className="input-group-prepend"> <span
                  className="input-group-text">Total</span> </div>
                <input onChange={this.onChange} id="total"
                  type="number" className="form-control" value={Number(this.state.total).toFixed(2)} placeholder="0.00" />
                <span className="text-danger">{errors.total}</span>
                <div className="input-group-append"> <span
                  className="input-group-text">USDT</span> </div>
              </div>
              <div className="quantity-main d-flex justify-content-between">
                <div className="quantity-outer"> <button type="button" disabled={this.state.btnDisable} className="crypt-button-green-full" onClick={() => this.addQuantity(5)}>5%</button></div>
                <div className="quantity-outer"> <button type="button" disabled={this.state.btnDisable} className="crypt-button-green-full" onClick={() => this.addQuantity(25)}>25%</button></div>
                <div className="quantity-outer"> <button type="button" disabled={this.state.btnDisable} className="crypt-button-green-full" onClick={() => this.addQuantity(50)}>50%</button></div>
                <div className="quantity-outer"> <button type="button" disabled={this.state.btnDisable} className="crypt-button-green-full" onClick={() => this.addQuantity(100)}>100%</button></div>
              </div>
              <div><button disabled={this.state.btnDisable} type="submit" className="crypt-button-red-full">Sell</button>
              </div>
            </div>
          </div>
        </form>
        <Toaster position="bottom-right" reverseOrder={false} />
      </div>
    )
  }
}
SellOrder.propTypes = {
  order: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  orderdata: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth,
  orderdata: state.orderdata,
  errors: state.errors
});
export default connect(
  mapStateToProps,
  { order }
)(withRouter(SellOrder));